<script>
  import ClickOut from '../../../../utils/directives/clickout'
  export default{
    name: 'btn-status',
    props: {
      value: {required: true},
      Status: {required: true}
    },
    data () {
      return {
        open: false
      }
    },
    computed: {
      model: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', parseInt(value))
        }
      },
      status () {
        return this.Status[this.value]
      },
      getStatus () {
        return this.Status
      }
    },
    mounted () {},
    destroyed () {
    },
    methods: {
      toggle () {
        this.open = !this.open
        this.$nextTick(() => {
          /* var nodes = this.$el.querySelectorAll('a')
          nodes[0].focus() */
        })
      },
      hide () {
        this.open = false
      },
      selectStatus (status) {
        this.model = status
      }
    },
    directives: {ClickOut},
    components: {}
  }
</script>

<template>
  <div class="btn-group dropdown" :class="{ open: open}"  v-click-out="hide">
    <button class="btn btn-sm" :class="'btn-' + status.class" data-toggle="dropdown" tabindex="1" aria-expanded="false" @click.stop.prevent="toggle"><i class="fa fa-check"></i> {{ status.titulo }} <span class="caret"></span></button>
    <ul @click="hide" class="dropdown-menu no-padder">
      <li v-for="(s,k) in getStatus" v-if="parseInt(k)!== parseInt(value)"><a tabindex="2" @click="selectStatus(k)" @keyup.enter="selectStatus(k)"><span class="label label-sm m-r-xs" :class="'bg-' + s.class">&nbsp;</span> {{ s.titulo }}</a></li>
    </ul>
  </div>
</template>
<style scoped>
.btn-pink{
  background-color: #ff00e6;
}
.btn-orange{
  background-color: #ffa600;
}
.btn-brown{
  background-color: #1d1810cd;
  color: white
}
.btn-brown{
  background-color: #1d1810cd;
  color: white
}
.btn-purple{
  background-color: #6b1876e5;
  color: white
}

</style>



// WEBPACK FOOTER //
// BtnStatus.vue?123a44ac